"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = exports.DOWNLOADER_ID = void 0;
// (C) 2019-2021 GoodData Corporation
exports.DOWNLOADER_ID = "downloader";
function downloadFile(uri) {
    var anchor = document.createElement("a");
    anchor.id = exports.DOWNLOADER_ID;
    anchor.href = uri;
    anchor.download = uri;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}
exports.downloadFile = downloadFile;
//# sourceMappingURL=downloadFile.js.map